module.exports = __webpack_public_path__ + "static/img/ag_5.990c8a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ag_5.png
// module id = 872
// module chunks = 1